const asmoCharTable = [
	{
		char: [
			'',
			'j',
			'k',
			'h',
			'i',
			'n',
			'o',
			'l',
			'm',
			'r',
			's',
			'p',
			'q',
			'v',
			'w',
			't',
			'u',
			'z',
			'G',
			'b',
			'c',
			'J',
			'a',
			'f',
			'g',
			'd',
			'e',
		],
		next: [
			0,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			3,
			2,
			2,
			3,
			2,
			2,
			2,
			2,
			2,
		],
	},
	{
		char: [
			'',
			'e',
			'f',
			'c',
			'd',
			'i',
			'j',
			'g',
			'h',
			'm',
			'n',
			'k',
			'l',
			'q',
			'r',
			'o',
			'p',
			'u',
			'v',
			's',
			't',
			'y',
			'z',
			'a',
			'b',
			'I',
			'J',
		],
		next: [
			0,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			2,
			2,
			3,
			3,
		],
	},
	{
		char: [
			'',
			'f',
			'g',
			'd',
			'e',
			'j',
			'k',
			'h',
			'i',
			'n',
			'o',
			'l',
			'm',
			'r',
			's',
			'p',
			'q',
			'v',
			'w',
			't',
			'u',
			'z',
			'G',
			'b',
			'c',
			'J',
			'a',
		],
		next: [
			0,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			3,
			2,
			2,
			3,
			2,
		],
	},
	{
		char: [
			'',
			'g',
			'h',
			'e',
			'f',
			'k',
			'l',
			'i',
			'j',
			'o',
			'p',
			'm',
			'n',
			's',
			't',
			'q',
			'r',
			'w',
			'x',
			'u',
			'v',
			'G',
			'H',
			'c',
			'd',
			'a',
			'b',
		],
		next: [
			0,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			3,
			3,
			2,
			2,
			2,
			2,
		],
	},
]

export default asmoCharTable
